import { Bolt, ExpandMore } from '@mui/icons-material';
import PsychologyAltIcon from '@mui/icons-material/Psychology';
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import Box from '@mui/system/Box';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setPage } from '../../../appNavigationSlice';
import { Survey } from '../../../types/Surveys';
import { setSurvey } from '../../surveydesigner/SurveyDesignerSlice';
import { selectSelectedTeam } from '../../user/teamsSlice';
import CreateSurveyForm from '../header/CreateSurveyForm';

export default function LeftBar() {
  const dispatch = useAppDispatch();

  const [createSurveyFormOpen, setCreateSurveyFormOpen] = useState<boolean>(false);

  const selectedTeamState = useAppSelector(selectSelectedTeam);
  const surveys = selectedTeamState?.surveys;

  function handleEditSurvey(survey: Survey) {
    // Set the survey and then change the page.
    dispatch(setSurvey(survey));
    dispatch(setPage('editing'));
  }

  return (
    <Box sx={{ p: 3 }}>
      <Accordion expanded={true} elevation={0}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <ListItem>
            <ListItemIcon>
              <Bolt></Bolt>
            </ListItemIcon>
            <ListItemText sx={{ color: 'primary' }} color="primary">
              On Demand
            </ListItemText>
          </ListItem>
        </AccordionSummary>
        <AccordionDetails>
          {surveys?.map((s) => (
            // <Typography>{s.title}</Typography>;
            <MenuItem sx={{ ml: 4 }} key={s.id} onClick={() => handleEditSurvey(s)}>
              {/* <Button sx={{ textTransform: 'none' }}></Button> */}
              <ListItemText>{s.title}</ListItemText>
            </MenuItem>
          ))}
          <Button sx={{ ml: 2 }} startIcon={<Bolt />} color="primary" onClick={(e) => setCreateSurveyFormOpen(true)}>
            Launch New Project
          </Button>
        </AccordionDetails>
        <AccordionActions></AccordionActions>
      </Accordion>

      <Accordion expanded={true} elevation={0}>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <ListItem>
            <ListItemIcon>
              <PsychologyAltIcon></PsychologyAltIcon>
            </ListItemIcon>
            <ListItemText sx={{ color: 'primary' }} color="primary">
              Methodologies
            </ListItemText>
          </ListItem>
        </AccordionSummary>
        <AccordionDetails>
          <Button
            sx={{ ml: 2 }}
            startIcon={<PsychologyAltIcon />}
            color="primary"
            onClick={(e) => setCreateSurveyFormOpen(true)}
          >
            Launch New Methodology
          </Button>
        </AccordionDetails>
      </Accordion>

      {createSurveyFormOpen && <CreateSurveyForm handleClose={() => setCreateSurveyFormOpen(false)} />}
    </Box>
  );
}
